//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Group, Cell } from 'vux'
import { mapGetters } from 'vuex'

export default {
  name: 'profile',
  computed: {
    ...mapGetters('profile', ['name', 'username', 'headIcon'])
  },
  filters: {
    prefix (username) {
      return username && `微信号：${username}`
    }
  },
  components: {
    Group,
    Cell
  }
}
